import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const JTKNightSakura = () => (
  <ArticleWrapper articleId="jtk_night_sakura">
    <div className="prose prose-invert mx-auto p-6">
      <h1>JTK Night Sakura</h1>
      {/* Add your JTK Night Sakura article content here */}
      <p>This is a placeholder article for the JTK Night Sakura keycap set. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default JTKNightSakura;
